<template>
    <v-btn variant="text" size="default" color="primary" class="pa-3 d-flex border-sm bg-bg-focused mr-2" @click="$emit('click')">
        <template #prepend>
            <svg-icon :icon="document" alt="file" />
        </template>
        {{ fileName }}
    </v-btn>
</template>

<script setup lang="ts">
import document from '@/assets/document.svg';
import SvgIcon from '@/features/common/components/SvgIcon.vue';

interface IIssueDetailsSingleFileEmit {
    (e: 'click'): void;
}

defineEmits<IIssueDetailsSingleFileEmit>();

interface IIssueDetailsSingleFile {
    fileName: string;
}

defineProps<IIssueDetailsSingleFile>();
</script>
